class Post {
    constructor({ id, userId, userName, userProfilePic, content, imageUrl, createdAt, likes, commentsCount }) {
        if (!id || !userId || !userName || !content || !createdAt) {
            throw new Error('Post entity requires id, userId, userName, content, and createdAt.');
        }

        this.id = id;
        this.userId = userId;
        this.userName = userName;
        this.userProfilePic = userProfilePic;
        this.content = content;
        this.imageUrl = imageUrl;
        this.createdAt = createdAt;
        this.likes = likes || []; // Array of user IDs who liked the post
        this.commentsCount = commentsCount || 0;
    }

    // Add methods for business logic related to a Post here
    // For example:
    // addLike(userId) { ... }
    // removeLike(userId) { ... }
    // addComment() { ... }
}

export default Post;
